import styles from "./Catalog.module.css"
import { copyToClipboard } from "../../../../../utils/clipboard";
import SecondaryButton from "../../../../../components/Button/SecondaryButton/SecondaryButton";
import { useTranslation } from "react-i18next";
import { Subscriber } from "../../../../../types/auth.types";
import { useUserContext } from "../../../../../context/UserContext";
import { useCartContext } from "../../../../../context/CartContext";
import { useOrderContext } from "../../../../../context/OrderContext";
import { useSearchParams, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from "react";
import { log } from "../../../../../utils/logger";
const REACT_APP_ENV = (window as any).REACT_APP_ENV ?? "test";
export const URL = REACT_APP_ENV=== "prod"
    ? "https://catermat-eshop-prod-475202341553.europe-west4.run.app/public-catalog"
    : "https://catermat-eshop-475202341553.europe-west4.run.app/public-catalog";
/**
* Catalog page
* Contains public catalog url
* @returns TSX.Element
*/
const CatalogPage = () => {
    const { t } = useTranslation(); // Translation
    const { userData } = useUserContext();
    const { cartData } = useCartContext();
    const {orderData, handleOrder} = useOrderContext(); // Order data
    const [user, setUser] = useState<Subscriber>()
    
    // Brani uuid
    const { stage } = useParams();
    const location = useLocation();
    const [otp, setOtp] = useState<string | null>(null)
    const [searchParams, setSearchParams] = useSearchParams(); // For ?stage=reset param
    const [uuid, setUuid] = useState<string | null>(null)
    useEffect(() => {
        const hasUUID = !!searchParams.get('uuid');
        if (hasUUID) {
            //log("Current uuid parameter: " + searchParams.get('uuid'))
            setUuid(searchParams.get('uuid'))
        }else  {
            //log("uuid parameter missing.")
        }
    }, [stage, searchParams, location.pathname]);

    useEffect(() => {
        const u = userData?.subscribers?.find(sub => sub.subscriber_id === orderData.recipient)
        setUser(u)
    }, [userData])
    // Sample catalog address
    const catalogAddress = `${URL}?uuid=${user?.uuid}`

    return(
        <>
            <div className={styles.CatalogPageContent}>
                <p className={styles.CatalogPageContentTitle}>{t("account.titles.catalog")}</p>
                <div className={styles.CatalogPageContentCenter}>
                    <div className={styles.CatalogAddress}>
                        <p className={styles.CatalogAddressTitle}>{t("account.catalog.base_form_title")}</p>
                        <div className={styles.CatalogAddressContent}>
                            <div className={styles.CatalogAddressInput}>
                                <div className={styles.InfoInputGroup}>
                                    <p>{t("account.catalog.inputs.address.title")}</p>
                                    <div className={styles.PrimaryInputBlock}>
                                        <div className={styles.PrimaryInputCenter}>
                                            <div className={styles.PrimaryInputField}>
                                                <p>{catalogAddress}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SecondaryButton
                            text={t("buttons.copy")}
                            onClick={()=>copyToClipboard(catalogAddress)}
                            showChevron={false}
                            className={styles.CopyButton}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CatalogPage;
